import React, { FC, PropsWithChildren, useRef } from 'react';
import { HeightCoordinator } from '@app/hooks/useHeightCoordinator';
import useMountEffect from '@app/hooks/useMountEffect';

interface Props {
  heightCoordinator: HeightCoordinator;
}

const HeightCoordinatedDiv: FC<PropsWithChildren<Props>> = ({ heightCoordinator, children }) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useMountEffect(() => {
    heightCoordinator.addRef(ref);

    return (): void => {
      heightCoordinator.removeRef(ref);
    };
  });

  return <div ref={ref}>{children}</div>;
};

export default HeightCoordinatedDiv;
